<a *ngIf="id && name && programImg" [routerLink]="['/programs', id]"
  ><img class="program-img rounded" alt="program image" [src]="programImg" />{{
    name
  }}</a
>
